import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;


export const fetchgetCaterogoriasEspeciales = async () => {
    const url = `${apiUrl}/getCategoriasEspeciales`
    try {
        const response = await axios.get(url)
        return response;
    } catch (error) {
        console.log('Hubo un error al obtener las categorías especiales: ', error)
        throw error 
    }
}